<template>
  <div v-loading="loading">
    <div v-if="ant_shield != ''">
      <el-button type="warning" plain @click="shengcehng">重新生成该报告</el-button>
      <div class="id">唯一ID标识{{ securityId }}</div>
      <div class="zong">
        总风险决策结果--<span class="yanse">{{ chenggong }}</span>
      </div>
      <div class="zong">模型及风险场景的决策结果</div>
      <table border="1" class="biaoge">
        <tr>
          <th>风险场景编码</th>
          <th>风险分值</th>
          <th>风险决策结果</th>
        </tr>
        <tr>
          <th>{{ sceneCode }}</th>
          <th>{{ score }}</th>
          <th>{{ decision }}</th>
        </tr>
      </table>
      <div class="celuo">策略结果详情</div>
      <table border="1" class="biaoge">
        <tr>
          <th>策略名称</th>
          <th>策略决策结果</th>
          <th>风险场景编码</th>
        </tr>
        <tr>
          <th>pre_launch_verify</th>
          <th class="yanse">{{ decision1 }}</th>
          <th>{{ sceneCode }}</th>
        </tr>
        <tr>
          <th>aaf_midlow_v31</th>
          <th class="yanse">{{ decision2 }}</th>
          <th>{{ sceneCode }}</th>
        </tr>
        <tr>
          <th>dummy_strategy_after_switch</th>
          <th class="yanse">{{ decision3 }}</th>
          <th>{{ sceneCode }}</th>
        </tr>
      </table>
    </div>

    <div v-else class="bgelse">
      <div class="tishi">提示：请生成报告后再查看该报告！</div>
      <div class="baogao">欺诈报告没有生成</div>
      <div class="shhengcheng">
        <el-button type="warning" plain @click="shengcehng">生成该报告</el-button>
      </div>
    </div>

  </div>
</template>
  
<script>
import FengkongApi from "@/api/fengkong.js";
import Table from "../../product/product/part/spec/many/Table.vue";
export default {
  components: { Table },
  props: ["zxid", "ant_shield","auth_no"],
  data() {
    return {
      loading: false,
      decision: "",
      securityId: "",
      chenggong: "",
      sceneCode: "",
      score: "",
      jieguo: "",
      jieguo1: "",
      name1: "",
      decision1: "通过",
      decision2: "通过",
      decision3: "通过",
    };
  },
  created() {
    let self = this;
    // console.log(self.auth_no);
    if(self.ant_shield == "" && self.auth_no){
      console.log("走了付款自动执行");
      self.shengcehng();
    }
    // console.log("**************************",typeof(this.ant_shield))
    if (self.ant_shield == '') {
      return
    }
    let zhengxin = JSON.parse(self.ant_shield);
    // console.log("sadasdadasdasdasdsa", zhengxin);
    //总风险决策结果
    if (zhengxin.decision == "reject") {
      zhengxin.decision = "拒绝";
    } else if (zhengxin.decision == "validate") {
      zhengxin.decision = "待定";
    } else if (zhengxin.decision == "accept") {
      zhengxin.decision = "通过";
    }
    self.chenggong = zhengxin.decision;
    //唯一ID标识
    self.securityId = zhengxin.securityId;
    //风险场景编码
    self.sceneCode = zhengxin.models[0].sceneCode;
    //风险分值
    self.score = zhengxin.models[0].score;
    //风险决策结果
    if (zhengxin.scenes[0].decision == "reject") {
      zhengxin.scenes[0].decision = "拒绝";
    } else if (zhengxin.scenes[0].decision == "validate") {
      zhengxin.scenes[0].decision = "待定";
    } else {
      zhengxin.scenes[0].decision = "通过";
    }
    self.decision = zhengxin.scenes[0].decision;
    self.decision1 = zhengxin.strategies[0].decision;
    self.decision2 = zhengxin.strategies[1].decision;
    self.decision3 = zhengxin.strategies[2].decision;
  },

  methods: {
    shengcehng() {
      let self = this;
      self.loading = true;
      let Params = { order_id: self.zxid };
      FengkongApi.yidun(Params, true)
        .then((data) => {
          // location.reload();
          self.ant_shield = 123;
          let zhengxin = JSON.parse(data.data.data.data);
          console.log("zhengxin", zhengxin);
          //总风险决策结果
          if (zhengxin.decision == "reject") {
            zhengxin.decision = "拒绝";
          } else if (zhengxin.decision == "validate") {
            zhengxin.decision = "待定";
          } else if (zhengxin.decision == "accept") {
            zhengxin.decision = "通过";
          }
          self.chenggong = zhengxin.decision;
          //唯一ID标识
          self.securityId = zhengxin.securityId;
          //风险场景编码
          self.sceneCode = zhengxin.models[0].sceneCode;
          //风险分值
          self.score = zhengxin.models[0].score;
          //风险决策结果
          if (zhengxin.scenes[0].decision == "reject") {
            zhengxin.scenes[0].decision = "拒绝";
          } else if (zhengxin.scenes[0].decision == "validate") {
            zhengxin.scenes[0].decision = "待定";
          } else {
            zhengxin.scenes[0].decision = "通过";
          }
          self.decision = zhengxin.scenes[0].decision;
          self.decision1 = zhengxin.strategies[0].decision;
          self.decision2 = zhengxin.strategies[1].decision;
          self.decision3 = zhengxin.strategies[2].decision;
          self.loading = false;
          self.$message({
            message: '加载完成',
            type: 'success'
          });
        })
        .catch((error) => {});
    },
  },
};
</script>
  
<style>
.zong {
  font-size: 20px;
  margin-left: 700px;
}
.yanse {
  color: green;
}
.biaoge {
  border-collapse: collapse;
  width: 100%;
}
.celuo {
  font-size: 20px;
  margin-left: 700px;
}
.id {
  font-size: 10px;
}
</style>
  


// WEBPACK FOOTER //
// src/views/fengkong/operation/detail2.vue